import "bootstrap/dist/css/bootstrap.min.css";

// load configs
import React from "react";
import ReactDOM from "react-dom";
import { ApolloProvider } from "@apollo/client";

// redux
import configureStore from "./store/configureStore";
import { Provider as ReduxProvider } from "react-redux";

// Components
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import UAParser from "ua-parser-js";

// utils
import { initApollo } from "./graphql/init";
import { tokenInterceptor, errorHandlingInterceptor } from "./interceptors";
import { setRollbarUserInfo } from "./loggers";

// configure apollo client
let client = initApollo();

// get user and token from local storage
const _user = localStorage.getItem("user");
const user = _user ? JSON.parse(_user) : null;
const token = localStorage.getItem("token");
const isLogin = token && user && user.roles ? true : false;

// set up redux store
const store = configureStore({
  auth: isLogin ? { user, isLogin } : { user: null, isLogin },

  teachingMode: { mode: sessionStorage.getItem("mode") || "" }
});
errorHandlingInterceptor(store.dispatch);
if (isLogin) {
  setRollbarUserInfo(user);
  tokenInterceptor(true);

  // Initialize UAParser and log device information
  const parser = new UAParser(window.navigator.userAgent);
  const result = parser.getResult();

  // Enhanced tablet/iPad detection
  const isTablet = () => {
    // Check UAParser device type first
    if (result.device.type === "tablet") return true;

    // iPad detection (iOS 13+ reports as desktop)
    const isIPad =
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) ||
      navigator.platform === "iPad" ||
      /iPad/.test(navigator.userAgent);

    // Android tablet detection
    const isAndroidTablet =
      /Android/.test(navigator.userAgent) &&
      !/Mobile/.test(navigator.userAgent);

    return isIPad || isAndroidTablet;
  };

  const isMobile =
    result.device.type === "mobile" ||
    (/Mobile/.test(navigator.userAgent) && !isTablet());

  const deviceType = isTablet() ? "tablet" : isMobile ? "mobile" : "desktop";

  // Get specific device name for iPads
  const getDeviceName = () => {
    if (isTablet()) {
      if (navigator.platform === "MacIntel" || navigator.platform === "iPad") {
        return "iPad";
      }
      return result.device.model || "Android Tablet";
    }
    return result.device.model || result.device.vendor || "Unknown";
  };

  const deviceInfo = {
    deviceType: deviceType,
    deviceName: getDeviceName(),
    ua: result.ua,
    device: result.device,
    os: result.os,
    browser: result.browser,
    maxTouchPoints: navigator.maxTouchPoints,
    screenSize: {
      width: window.screen.width,
      height: window.screen.height,
      pixelRatio: window.devicePixelRatio
    }
  };

  // Store device info in localStorage for access throughout the app
  localStorage.setItem("deviceInfo", JSON.stringify(deviceInfo));
}

ReactDOM.render(
  <ReduxProvider store={store}>
    <ApolloProvider client={client}>
      <div
        style={{
          minHeight: "100vh",
          height: "100vh",
          display: "flex",
          flexDirection: "column"
        }}
      >
        {/* <CssBaseline /> */}
        <App />
      </div>
    </ApolloProvider>
  </ReduxProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorkerRegistration.unregister();
